<template>
  <div>
    <!-- HEADER -->
    <vs-row>
      <vs-col vs-type="flex" vs-align="flex-start" vs-justify="flex-start" vs-w="8" class="px-2">
        <feather-icon
            class="inline-flex mr-4"
            icon="UserIcon" />
        <h3>{{item.list_study_name}}</h3>
      </vs-col>
      <vs-col vs-type="flex" vs-align="flex-end" vs-justify="flex-end" vs-w="4" class="px-6">
        <vx-tooltip text="Permalink: Click to view in separate window" position="right">
        <vs-button target :href="{ url: '/apps/Barretts/patients/view/' + item.participant_id }" icon-pack="feather" icon="icon-external-link"></vs-button>
        </vx-tooltip>
      </vs-col>
    </vs-row>
    <!-- END: HEADER -->

    <vs-tabs>
      <vs-tab class="px-0" icon="face" @click="initPopup(item)" label="Demographics"><demographics :item="item" ref="demographics" /></vs-tab>
      <vs-tab class="px-0" icon="launch" @click="initPopup(item)" label="Lifestyle"><lifestyle :item="item" ref="lifestyle" /></vs-tab>
      <vs-tab class="px-0" icon="launch" @click="initPopup(item)" label="Endoscopy"><endoscopy :item="item" ref="endoscopy" /></vs-tab>
      <vs-tab class="px-0" icon="label" @click="initPopup(item)" label="Sample"><sample :item="item" ref="sample" /></vs-tab>
      <vs-tab class="px-0" icon="list" @click="initPopup(item)" label="Pathology"><pathology :item="item" ref="pathology" /></vs-tab>
      <vs-tab class="px-0" icon="explore" @click="initPopup(item)" label="Intervention"><intervention :item="item" ref="intervention" /></vs-tab>
      <vs-tab class="px-0" icon="subject" @click="initPopup(item)" label="Drug history"><comorbidity :item="item" ref="comorbidity" /></vs-tab>
      <vs-tab class="px-0" icon="subject" @click="initPopup(item)" label="Surveillance"><surveillance :item="item" ref="surveillance" /></vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
export default{
	data() {
		return {
			// activeTab: 'endoscopy',
		}
	},
  props: {
    item: {
      type: Object,
      required: true
    },
  },
	components: {
    Demographics: () => import("./tabs/Demographics.vue"),
    Lifestyle: () => import("./tabs/Lifestyle.vue"),
    Endoscopy: () => import("./tabs/Endoscopy.vue"),
    Sample: () => import("./tabs/Sample.vue"),
    Pathology: () => import("./tabs/Pathology.vue"),
    Intervention: () => import("./tabs/Intervention.vue"),
    Comorbidity: () => import("./tabs/Comorbidity.vue"),
    Surveillance: () => import("./tabs/Surveillance.vue"),
  },
  methods: {
    initPopup(participant) {
      this.$nextTick(() => {
        if(this.$refs.demographics){this.$refs.demographics.getRecords(participant.participant_id);}
        if(this.$refs.lifestyle){this.$refs.lifestyle.getRecords(participant.participant_id);}
        if(this.$refs.endoscopy){this.$refs.endoscopy.getRecords(participant.participant_id);}
        if(this.$refs.sample){this.$refs.sample.getRecords(participant.participant_id);}
        if(this.$refs.pathology){this.$refs.pathology.getRecords(participant.participant_id);}
        if(this.$refs.intervention){this.$refs.intervention.getRecords(participant.participant_id);}
        if(this.$refs.comorbidity){this.$refs.comorbidity.getRecords(participant.participant_id);}
        if(this.$refs.surveillance){this.$refs.surveillance.getRecords(participant.participant_id);}
        // Todo surveillance
      });
    },
  },
}
</script>
<style>
.tabNavs .con-vs-chip {
  cursor: pointer;
}
.vs-list--item .list-titles .vs-list--subtitle,
.vs-card--content {
  font-size: 0.95rem;
}
.con-vs-popup .vs-popup {
  width: 1200px;
  height: 100%;
}
.vs-tabs--btn {
  font-weight: bold;
}
</style>
